import { createContext } from 'react';
import { ScheduleFormWidgetContextValue } from './types';

export const ScheduleFormWidgetContext = createContext<ScheduleFormWidgetContextValue | null>(null);
